
import { Ref, Prop } from "vue-property-decorator";
import { SelectableProfile, UserRDStats } from "../../types";
import ChartMixin from "../../helpers/mixins/chart";
export default class RDAnalyticsChart extends ChartMixin {
  @Prop({ type: Array, required: true }) stats: UserRDStats[] = [];
  @Prop({ type: Object }) focus: Partial<SelectableProfile> = {};
  @Ref("table") table!: HTMLElement;
  draw() {
    this.$forceUpdate();
  }
  calculatePosition(stats: UserRDStats) {
    const x = stats.axis.rd_mx > 80 ? 80 : stats.axis.rd_mx < 20 ? 20 : stats.axis.rd_mx;
    const y = stats.axis.rd_my > 100 ? 100 : stats.axis.rd_my < 0 ? 0 : stats.axis.rd_my;
    const circleWidth = 14.75;
    const circleHeight = 18;
    return {
      left: `calc(${(5 * x - 100) / 3}% - ${circleWidth / 2}px)`,
      bottom: `calc(${y}% - ${circleHeight / 2}px`
    };
  }
}
